<template>
    <div class="about-social-priority" v-if="pageSetup != null">
        <div class="container">
            <div class="priority-title">
                <h2 v-html="pageSetup.about_social.corp.priority_title"></h2>
                <div class="title-desc"><p v-html="pageSetup.about_social.corp.priority_title_desc"></p></div>
            </div>
            <div class="priority-icon-items">
                <div class="priority-item" v-for="(item, index) in pageSetup.about_social.corp.priority_list">
                    <div class="icon-item" >
                        <span>0{{ index + 1 }}</span>
                        <img :src="item.icon" alt="">
                    </div>
                    <h4>{{ item.title }}</h4>
                </div>
            </div>
            <div class="priority-unique-desc">
                <div class="column-container">
                    <div class="col-left">
                        <div class="desc-red">
                            <img src="https://bcn.kz/cms/media/important-icon.svg" alt="">
                            <strong v-html="pageSetup.about_social.corp.priority_desc_red"></strong>
                        </div>
                    </div>
                    <div class="col-right">
                        <div class="col-desc" v-html="pageSetup.about_social.corp.priority_desc_right"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'about-social-priority-section',
        components: {
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            pageSetup: 'loadAboutPage',
        }),
        methods: {
            startLoader() {
                // this.$parent.$parent.$refs.topProgress.start();
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/about-page/about-social-priority.scss';
    @import '@/styles/components/about-page/respond/about-social-priority-respond.scss';
</style>